<template>
  <div class="app-customizer">
    <v-navigation-drawer
      v-model="isCustomizerOpen"
      hide-overlay
      right
      temporary
      fixed
      width="400"
      class="app-customizer-drawer"
    >
      <v-card flat>
        <v-card-title>
          <div
            style="width: 100%"
            class="text-center text--primary title font-weight-bold"
          >
            Preferências de Estilo
          </div>
          <v-spacer></v-spacer>
          <BtnCloseDrawer @close="isCustomizerOpen = false"></BtnCloseDrawer>
          <!-- <v-btn
            icon
            class="icon-customizer-close"
            @click="isCustomizerOpen = false"
          >
            <v-icon>
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Heading -->

          <!-- <perfect-scrollbar
            :options="perfectScrollbarOptions"
            class="ps-customizer"
          > -->
          <!-- Section: Themeing -->
          <div class="customizer-section">
            <p class="text--disabled mt-2 subtitle-1">TEMA</p>
            <!-- Skin -->
            <span class="text--primary subtitle-1"> Estilo </span>
            <v-radio-group
              v-model="appSkinVariant"
              gclass="mt-1"
              hide-details
              row
            >
              <v-radio
                v-for="option in skinVariantOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
            <!-- Mode -->
            <span class="mt-6 d-inline-block mb-2 text--primary subtitle-1">Modo</span>
            <div class="d-flex align-center mb-6">
              <span class="text--secondary text-sm subtitle-1 mr-3">Claro</span>
              <v-switch
                v-model="isDark"
                inset
                hide-details
                class="mt-0 mx-2"
              ></v-switch>
              <span class="text--secondary text-sm subtitle-1">Escuro</span>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Section: Themeing -->
          <div class="customizer-section">
            <p class="text--disabled mt-2 subtitle-1">LAYOUT</p>

            <!-- Content Width -->
            <span class="text--primary subtitle-1">Largura do Conteúdo</span>
            <v-radio-group
              v-model="appContentWidth"
              class="mt-1"
              hide-details
              row
            >
              <v-radio
                v-for="option in appContentWidthOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              ></v-radio>
            </v-radio-group>

            <!-- AppBar Type -->
            <span class="mt-6 d-inline-block text--primary subtitle-1">Barra de Pesquisa</span>
            <v-radio-group
              v-model="appBarType"
              class="mt-1"
              hide-details
              row
            >
              <v-radio
                v-for="option in appBarTypeOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              ></v-radio>
            </v-radio-group>

            <!-- Footer Type -->
            <!-- <span class="mt-6 d-inline-block text--primary">Footer Type</span>
              <v-radio-group v-model="footerType" class="mt-1" hide-details row>
                <v-radio
                  v-for="option in footerTypeOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></v-radio>
              </v-radio-group> -->

            <!-- Blur -->
            <!-- <div class="d-flex align-center justify-space-between mt-6">
                <span class="text--primary">Desfoque da Barra de Aplicativos</span>
                <v-switch
                  v-model="appBarIsBlurred"
                  hide-details
                  class="mt-0 ms-2"
                ></v-switch>
              </div> -->
          </div>

          <v-divider class="mt-4"></v-divider>

          <!-- Section: Menu -->
          <div class="customizer-section">
            <p class="text-xs text--disabled mt-2 subtitle-1">BARRA MENU LATERAL</p>
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <!-- Menu Layout -->
              <!-- <span class="text--primary">Layout do Menu</span> -->
              <!-- <v-radio-group
                  v-model="appContentLayoutNav"
                  class="mt-1"
                  hide-details
                  row
                >
                  <v-radio
                    v-for="option in appContentLayoutNavOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group> -->
            </template>

            <!-- Menu Collapsed -->
            <div
              v-if="appContentLayoutNav === 'vertical'"
              class="d-flex align-center justify-space-between mt-6"
            >
              <span class="text--primary subtitle-1">Menu Recolhido</span>
              <v-switch
                v-model="menuIsVerticalNavMini"
                inset
                hide-details
                class="mt-0 ms-2 mb-0"
              ></v-switch>
            </div>

            <!-- Menu Hidden -->
            <!-- <div class="d-flex align-center justify-space-between mt-6">
                <span class="text--primary">Ocultar Menu</span>
                <v-switch
                  v-model="menuIsMenuHidden"
                  hide-details
                  class="mt-0 ms-2"
                ></v-switch>
              </div> -->
          </div>
          <!-- <v-divider></v-divider> -->
          <!-- Section: Misc -->
          <!-- <div class="customizer-section">
          <p class="text-xs text--disabled">
            MISC
          </p> -->
          <!-- RTL -->
          <!-- <div class="d-flex align-center justify-space-between mt-6">
            <span class="text--primary">RTL</span>
            <v-switch
              v-model="isRtl"
              hide-details
              class="mt-0 ms-2"
            ></v-switch>
          </div> -->
          <!-- Router Transition -->
          <!-- <v-row class="mt-6 align-center">
            <v-col><span class="text--primary">Router Transition</span></v-col>
            <v-col col="4">
              <v-select
                v-model="appRouteTransition"
                :items="routerTransitionOptions"
                outlined
                hide-details
                dense
                class="select-router-transition"
              ></v-select>
            </v-col>
          </v-row>
        </div> -->
          <!-- </perfect-scrollbar> -->
        </v-card-text>
        <div style="position: fixed; bottom: 0px; width: 100%">
          <v-divider class=""></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="btnLoading"
              color="primary"
              block
              x-large
              @click="save()"
            >
              <v-icon>{{ icons.mdiContentSaveOutline }}</v-icon> Salvar
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
// import { computed, ref } from "@vue/composition-api";
// import useAppConfig from "@core/@app-config/useAppConfig";

import { mdiCog, mdiClose, mdiContentSaveOutline } from '@mdi/js'

import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

// import themeVariants from "./themeVariants";
import { mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store'
import BtnCloseDrawer from '@/components/BtnCloseDrawer.vue'

// 3rd Party

export default {
  components: {
    PerfectScrollbar,
    BtnCloseDrawer,
  },
  data() {
    return {
      btnLoading: false,
      skinVariantOptions: [
        { label: 'Padrão', value: 'default' },
        { label: 'Com Borda', value: 'bordered' },
        { label: 'Semi Escuro', value: 'semi-dark' },
      ],
      appContentWidthOptions: [
        { label: 'Largura Total', value: 'full' },
        { label: 'Caixa', value: 'boxed' },
      ],
      appBarTypeOptions: [
        { label: 'Fixo', value: 'fixed' },
        { label: 'Estático', value: 'static' },
        // { label: 'Oculto', value: 'hidden' },
      ],
      perfectScrollbarOptions: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },

      // appContentWidth: "full",
      // isVertical: "yes",
      // appSkinVariant: "default",
      appContentLayoutNavOptions: [
        { label: 'Vertical', value: 'vertical' },
        { label: 'Horizontal', value: 'horizontal' },
      ],

      // useAppConfig,
      icons: {
        mdiCog,
        mdiClose,
        mdiContentSaveOutline,
      },
    }
  },
  watch: {},
  computed: {
    ...mapGetters('appConfig', ['getDialog']),
    isDark: {
      get() {
        return this.$vuetify.theme.dark
      },
      set(value) {
        this.$vuetify.theme.dark = value
        localStorage.setItem('materio-active-theme', value ? 'dark' : 'light')
      },
    },
    appSkinVariant: {
      get: () => store.state.appConfig.app.skinVariant,
      set: value => {
        store.commit('appConfig/UPDATE_APP_SKIN_VARIANT', value)
        localStorage.setItem('materio-skin-variant', value)
      },
    },

    appContentWidth: {
      get: () => store.state.appConfig.app.contentWidth,
      set: value => {
        store.commit('appConfig/UPDATE_APP_CONTENT_WIDTH', value)
      },
    },

    appBarType: {
      get: () => store.state.appConfig.appBar.type,
      set: value => {
        store.commit('appConfig/UPDATE_APP_BAR_TYPE', value)
      },
    },
    appBarIsBlurred: {
      get: () => store.state.appConfig.appBar.isBlurred,
      set: value => {
        store.commit('appConfig/UPDATE_APP_BAR_IS_BLURRED', value)
      },
    },
    appContentLayoutNav: {
      get: () => store.state.appConfig.app.contentLayoutNav,
      set: value => {
        store.commit('appConfig/UPDATE_CONTENT_LAYOUT_NAV', value)
      },
    },
    menuIsVerticalNavMini: {
      get: () => store.state.appConfig.menu.isVerticalNavMini,
      set: value => {
        store.commit('appConfig/TOGGLE_MENU_VERTICAL_NAV_MINI', value)
      },
    },
    menuIsMenuHidden: {
      get: () => store.state.appConfig.menu.isMenuHidden,
      set: value => {
        store.commit('appConfig/TOGGLE_MENU_MENU_HIDDEN', value)
      },
    },

    isCustomizerOpen: {
      get() {
        return this.getDialog
      },
      set(val) {
        this.setDialog(val)
      },
    },
  },
  methods: {
    ...mapMutations('appConfig', ['setDialog']),
    ...mapActions('appConfig', ['saveConfig']),

    save() {
      this.btnLoading = true
      this.saveConfig()
        .then(response => {
          this.$toast.success('Estilo salvo.')
          this.isCustomizerOpen = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.ps-customizer {
  height: calc(100% - 81px) !important;
}

.app-customizer-toggler {
  position: fixed;
  top: 50%;
  transform: translateX(-50%);
  background: var(--v-primary-base);
  @include ltr() {
    right: -22px;
  }
  @include rtl() {
    left: 20px;
  }
}

@include theme(app-customizer-drawer) using ($material) {
  background-color: map-deep-get($material, 'cards');
}

.app-customizer {
  z-index: 7;

  .v-label {
    font-size: 0.875rem;
  }

  .app-customizer-header {
    position: relative;
    .icon-customizer-close {
      position: absolute;
      @include ltr() {
        right: 20px;
      }
      @include rtl() {
        left: 20px;
      }
      top: 50%;
      transform: translateY(-50%);
    }
  }

  // Fixes Overlay is shown below SystemBar
  @at-root {
    .v-overlay {
      & + .v-application--wrap > .v-system-bar {
        z-index: 6 !important;
      }
    }
  }
}
</style>
